import { IStudyDocuments } from "./study-documents.interface";

export interface IAdminSite {
  address: string;
  id?: number;
  name: string;
  study_sites: Array<IStudyDocuments>;
}
